import React,{useState} from 'react';
import AnnoucementTemplate from 'src/components/Dialog';
import {TextField,Typography, Link, Box,IconButton} from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import { useHarvestingContext } from 'src/views/harvesting/harvesting-context'; 
import { useFirestore } from 'reactfire';
import { doc, setDoc } from 'firebase/firestore'; 

export const GroupRequiredDialog:React.FC = () => {

  const {requestedFacebookGroups} = useHarvestingContext();
  const firstRequestedFacebookGroup = requestedFacebookGroups[0]?? false;
  const [groupName,setGroupName] = useState('');
  const [hasClick, setHasClick] = useState(false);
  const db =useFirestore();
  const handleGroupName = (e: { clipboardData: { getData:(type:string)=>string}; })=>{
    setGroupName(e.clipboardData.getData('Text'));
  };

  if(!firstRequestedFacebookGroup){
    return <></>;
  }
  const submitGroupName = async ()=>{

    await setDoc(doc(db, 'facebookGroup', firstRequestedFacebookGroup), {
      name:groupName
    });
    setGroupName('');
    setHasClick(false);
  };
  console.log('requestedFacebookGroups',requestedFacebookGroups);
  return (
    <div>
      <AnnoucementTemplate
        open={true}
        title={`${requestedFacebookGroups.length} new Facebook Group is found. Please tell us it's name. 🙇‍♂️`}
        buttons={groupName!==''?[
          {
            name: 'Submit Group Name',
            color: 'primary',
            type: 'submit',
            clickFunc: ()=>{submitGroupName();},
            varient: 'contained',
          },
         
        ]:[]}
      >
        <Box pb={1}>
          <Typography variant='body1' gutterBottom>
            <strong>Step 1: </strong> Please <Link target='__blank' href={`https://www.facebook.com/groups/${firstRequestedFacebookGroup}/`} onClick={()=>setHasClick(true)}>Click here </Link>, and copy Facebook group name.
          </Typography>
        </Box>
        {hasClick && (
          <>
            <Box pb={1}>
              <Typography variant='body1' gutterBottom>
                <strong>Step 2: </strong> Paste Facebook group name in below box.
              </Typography>
            </Box>
            <TextField label="Group Name" placeholder="Paste facebook group name" variant='outlined' fullWidth value={groupName} autoFocus={true} onPaste={handleGroupName}
              helperText=" * Make sure that the group name here is accurate"
              InputProps={{
                endAdornment: (
                  <IconButton onClick={() => setGroupName('')}>
                    <ClearIcon />
                  </IconButton>
                )
              }}
            />
          </>
        )}
       
      </AnnoucementTemplate>
    </div>
  );
};

